import React, { useState, useRef } from 'react'
import { AccordionWrapper } from './AccordionContent.styles'

const AccordionContent = ({ title, content }) => {
  const [isOpen, setOpen] = useState(false)
  const contentRef = useRef(null)
  return (
    <AccordionWrapper
      onClick={() => setOpen(!isOpen)}
      role="button"
      tabIndex={0}
      onKeyDown={() => setOpen(!isOpen)}
    >
      <div className="title-wrapper">
        <p className="title">{title}</p>
        <div className="plus">
          <div className={`line${isOpen ? ' rotated' : ''}`} />
          <div className="line rotated" />
        </div>
      </div>
      <div
        ref={contentRef}
        className="content"
        style={{
          height: isOpen ? `${contentRef.current.scrollHeight}px` : '0px',
          overflow: 'hidden',
        }}
      >
        <p
          style={{
            opacity: isOpen ? `1` : '0',
          }}
        >
          {content}
        </p>
      </div>
    </AccordionWrapper>
  )
}

export default AccordionContent
